module.exports = __webpack_public_path__ + "img/20a-consultas-cadastros-show.e2d68000.png";